
<template>
    <Fragment>

        <!-- --------------------------------------- -->
        <!-- RENDER ELEMENT  -->
        <!-- --------------------------------------- -->

        <tr v-if="showSeparationLine">
            <td colspan="4" :style="showSeparationLine ? 'border-top: 1px solid #ccc' : ''"></td>
        </tr>

        <!-- KITS -->
        <Fragment>
            <!-- KITS NO OPCIONALS, VARIANTS -->
            <tr
                v-if="!isProduct && !element.optional &&
                    (
                        (!comeFromIsSimplePopup && !comeFromIsDoublePopup) ||
                        (comeFromIsSimplePopup || comeFromIsDoublePopup) && articlesQuantity()
                    )"
                v-show="((showElement && show) || showKitTitle)"
                class="p-2"
            >
                <td colspan="1" class="text-left">
                    <div style="display: inline-block">
                        <span
                            v-show="forceShowKits"
                        >{{ "-----".repeat(level) + ' ' + element.product_id }}</span>

                        <div v-if="app.p3_zoomedImage === 'img_no_opt' + randomId">
                            <LightBox
                                :images="getImagePreparedForLightbox(element.image, element.product_id)"
                                @onOpened="closeLightbox"
                            ></LightBox>
                        </div>

                        <img
                            @click="clickedImageToZoom('img_no_opt' + randomId)"
                            :id=" 'img_no_opt' + randomId"
                            :src="element.image"
                            alt
                            style="height:50px; width: auto;"
                            class="pointerHoverZoom"
                        />
                    </div>
                </td>

                <td
                    :colspan="element.isQuantityEditable &&
                            (!comeFromIsSimplePopup && !comeFromIsDoublePopup) ? '2' : '3'"
                    class="text-left"
                >
                    <div style="margin-left:0px">
                        <span v-if="! hideBorder">
                            <strong>
                                {{ element.name }}:</strong>
                        </span>
                        <span v-else-if="!element.optional">
                            <strong>{{ element.name }}:</strong>
                        </span>

                        <!-- BOTON VER VARIANTES -->
                        <button
                            v-if="element.type == 2"
                            type="button"
                            class="btn btn-outline-dark ml-2 buttonBarsSize"
                            data-bs-toggle="modal"
                            data-dismiss="modal"
                            :data-target=" '#modalVariant_' + randomId "
                            :data-bs-target=" '#modalVariant_' + randomId "
                        >
                            <i class="fas fa-bars position_bars"></i>
                        </button>
                    </div>
                </td>

                <td v-if="element.isQuantityEditable &&
                        (!comeFromIsSimplePopup && !comeFromIsDoublePopup)"
                    colspan="1"
                    class="text-center"
                >
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <div class="d-flex flex-row justify-content-center align-items-center">
                            <input
                                type="number"
                                min="0"
                                style="width:60px; text-align:center"
                                v-model="element.quantity"
                                :disabled="app.isProcessing"
                                @focus="app.p4Helper.ifCeroBlank(element)"
                                @blur="app.p4Helper.ifBlankCero(element)"
                                @change="app.p4Helper.process(element,$event)"
                                @keyup="app.p4Helper.onKeyUp(element,$event)"
                                @keydown="app.p4Helper.onKeyDown(element,$event)"
                                @click.stop
                            />
                        </div>
                        <span>{{ ' ' + element.unit_type }}</span>

                    </div>
                </td>
            </tr>

            <!-- KITS OPCIONALS -->
            <tr
                v-else-if="!isProduct && element.optional &&
                    (
                        (comeFromIsSimplePopup || comeFromIsDoublePopup) && articlesQuantity() ||
                        (!comeFromIsSimplePopup && !comeFromIsDoublePopup)
                    )"
                v-show="((showElement && show) || showKitTitle)"
            >
                <!-- img -->
                <td class="text-left">
                    <span
                        v-show="forceShowKits"
                    >{{ "-----".repeat(level) + ' ' + element.product_id }}</span>

                    <!-- IMATGE PER KITS OPCIONALS -->
                    <img
                        v-show="element.optional"
                        @click="clickedImageToZoom('img_' + randomId)"
                        :id=" 'img_' + randomId"
                        :src="element.image"
                        alt
                        style="height:50px; width: auto;"
                        class="pointerHoverZoom"
                    />
                </td>

                <!-- CHECKBOX PER KITS OPCIONALS -->
                <td
                    v-if = "!comeFromIsSimplePopup && !comeFromIsDoublePopup"
                    class="text-center"
                >
                    <div v-show="element.optional &&
                                !comeFromIsSimplePopup &&
                                !comeFromIsDoublePopup"
                         class="custom-control custom-switch"
                    >
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="randomId + '_optional'"
                            @change="selectedChange"
                            v-model="element.selected"
                        />
                        <label class="custom-control-label" :for="randomId + '_optional'"></label>
                    </div>
                </td>

                <!-- NOM DEL KIT -->
                <td :colspan = "comeFromIsSimplePopup || comeFromIsDoublePopup ? '3' : '2'"
                    class="text-left"
                >
                    <div :style="'margin-left: ' + (level-1) * 20 + 'px'">
                        <strong>
                            <!-- {{ "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;".repeat(level) }} -->
                            {{ element.name }}:
                        </strong>
                        <span>
                            <!-- BUTO EDITAR POPUP SOCKETS -->
                            <button
                                v-show="(isSimplePopup || isDoublePopup) && articlesQuantity() && element.selected"
                                type="button"
                                style="margin-top:0px;"
                                class="btn btn-outline-dark ml-3 buttonBarsSize"
                                @click="clickedEditButton()"
                            >
                                <i class="fas fa-bars position_bars"></i>
                            </button>
                        </span>
                    </div>
                </td>
            </tr>

        </Fragment>

        <!-- NO VARIANTS O AMB QUANTITAT NO EDITABLE -->
        <!-- RESTA ELEMENTS -->
        <Fragment
            v-if="isProduct"
            v-show="showElement && show"
        >
            <tr v-if="isProduct
                && (
                    (!comeFromIsSimplePopup && !comeFromIsDoublePopup) ||
                    ((comeFromIsSimplePopup || comeFromIsDoublePopup) && articlesQuantity())
                )"
                v-show="showElement && show"
            >
                <td colspan="1" class="m-0 p-0">
                    <div v-if="app.p3_zoomedImage === 'img_' + randomId">
                        <LightBox
                            :images="getImagePreparedForLightbox(element.image, element.product_id)"
                            @onOpened="closeLightbox"
                        ></LightBox>
                    </div>

                    <img
                        @click="clickedImageToZoom('img_' + randomId)"
                        :id=" 'img_' + randomId"
                        :src="element.image"
                        alt
                        style="height:50px; width: auto;"
                        class="pointerHoverZoom"
                    />
                </td>

                <!-- descripcion -->
                <td colspan="3" class="text-left pr-2 my-0 py-0">
                    <span>
                        {{ element.isKit == false ?
                        element.name :
                        element.description }}
                    </span>

                    <a
                        title="+Info"
                        :href="'https://www.unex.net/' + element.product_id"
                        target="_blank"
                    >
                        <i style="color:grey;" class="fas fa-external-link-alt ml-2"></i>
                    </a>
                    <i
                        v-if="element.notes"
                        v-b-tooltip.hover.html
                        :title="element.notes"
                        style="color:#e60000;"
                        id="dist_soport_info"
                        class="ml-2 fas fa-info-circle"
                    ></i>
                </td>
            </tr>

            <tr
                v-if="isProduct && (
                    (!comeFromIsSimplePopup && !comeFromIsDoublePopup) ||
                    ((comeFromIsSimplePopup || comeFromIsDoublePopup) && articlesQuantity())
                )"
                v-show="showElement && show"
                :class="{ isKit: element.isKit, open: showChilds }"
            >
                <!-- seleccion opcional ---  EXTRAS: TOGGLE SWITCH -->
                <td class="text-center m-0 p-0">
                    <div class="d-flex flex-row justify-content-around align-items-start">
                        <div
                            v-if="parentType !=2 && element.type == 3 && element.isKit==false"
                            class="custom-control custom-switch ml-2"
                        >
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="randomId"
                                v-model="element.selected"
                                @change="selectedChange"
                            />
                            <label class="custom-control-label" :for="randomId"></label>
                        </div>
                    </div>
                </td>

                <!-- ================================================= -->
                <!-- Cantidades  -->
                <!-- ================================================= -->
                <!-- Cantidades individuales -->
                <td class="text-center m-0 p-0" v-if="showQuantities || element.isQuantityEditable">
                    <div v-if="element.isQuantityEditable">
                        <div class="d-flex flex-row justify-content-center align-items-center">
                            <input
                                type="number"
                                min="0"
                                style="width:60px; text-align:center"
                                v-model="element.quantity"
                                :disabled="app.isProcessing"
                                @focus="app.p4Helper.ifCeroBlank(element)"
                                @blur="app.p4Helper.ifBlankCero(element)"
                                @change="app.p4Helper.process(element,$event)"
                                @keyup="app.p4Helper.onKeyUp(element,$event)"
                                @keydown="app.p4Helper.onKeyDown(element,$event)"
                                @click.stop
                            />
                        </div>
                    </div>

                    <div v-if="!element.isQuantityEditable" style="min-width:70px">
                        <span>{{ element.quantity | currency({
                            symbol: "",
                            fractionCount: 0
                        })}}</span>
                    </div>
                </td>

                <!-- Cantidades calculadas -->
                <td v-if="! showQuantities && ! element.isQuantityEditable" class="m-0 p-0">
                    <span>{{ element.quantityCalculated | currency({
                            symbol: "",
                            fractionCount: 0
                        })}}</span>
                </td>
                <!-- ================================================= -->

                <!-- PRICE -->
                <td style="min-width:70px" class="m-0 p-0">
                    <span>{{ (element.price * element.min_quantity) | currency }}</span>
                </td>

                <!-- SUBTOTAL -->
                <td style="min-width:90px" class="text-center m-0 p-0">
                    <span>{{ element.subtotal | currency  }}</span>
                </td>
            </tr>

            <!-- -------------- -->
            <!--    UNIDADES    -->
            <!-- -------------- -->
            <tr v-if="isProduct && (
                    (!comeFromIsSimplePopup && !comeFromIsDoublePopup) ||
                    ((comeFromIsSimplePopup || comeFromIsDoublePopup) && articlesQuantity())
                )"
                v-show="showElement && show">
                <td class="m-0 p-0"></td>

                <!-- Cantidades individuales -->
                <td class="text-center m-0 p-0" v-if="showQuantities || element.isQuantityEditable">
                    <span> {{ element.unit_type }}</span>
                </td>

                <!-- Cantidades calculadas -->
                <td v-if="! showQuantities && ! element.isQuantityEditable" class="m-0 p-0">
                    <span>{{ element.unit_type }}</span>
                </td>

                <!-- UNIDAD PRECIO -->
                <td class="m-0 p-0 text-center" style="min-width:85px" >
                    <span>
                        /{{ element.min_quantity > 1 ? element.min_quantity : '' }} {{ element.unit_type }}
                    </span>
                </td>

                <!-- MONEDA SUBTOTAL -->
                <td class="m-0 p-0 text-center" style="min-width:90px">
                    <!-- <span>{{ app.currentConfiguration.priceList.currency }}</span> -->
                </td>
            </tr>

        </Fragment>

        <!-- --------------------------------------- -->
        <!-- RENDER ELEMENT CHILDS que no son variantes -->
        <!-- --------------------------------------- -->
        <Fragment v-if="element.type != 2">
            <productElementMobileComponent
                :show="(showChilds || (element.isQuantityEditable &&
                    element.quantity && element.quantity !=0 ) ) && show"
                v-for="(child,i) in element.childs"
                :key="'pem_' + randomId + '_' + child.product_id"
                :element="child"
                :elementIndex="elementIndex"
                :parentType="element.type"
                :level="level + 1"
                :groupId="randomId"
                :forceShowKits="forceShowKits"
                :hideBorder="hideBorder || (showElement && show)"
                :showQuantities=" ! element.isQuantityEditable "
                :key_spinner="'pem_' + randomId + '_' + child.product_id"
                :comeFromIsSimplePopup = "isSimplePopup || comeFromIsSimplePopup ? true : false"
                :comeFromIsDoublePopup = "isDoublePopup || comeFromIsDoublePopup ? true : false"
            ></productElementMobileComponent>
        </Fragment>

        <!-- --------------------------------------- -->
        <!-- RENDER LOS CHILDS SELECCIONADOS DE VARIANTES -->
        <!-- --------------------------------------- -->
        <Fragment v-else-if="element.type == 2">
            <productElementMobileComponent
                v-for="(child,i) in element.childs"
                :show="show && child.selected"
                :key="'pem_' + randomId + '_' + child.product_id"
                :element="child"
                :elementIndex="elementIndex"
                :parentType="element.type"
                :level="level + 1"
                :groupId="randomId"
                :forceShowKits="forceShowKits"
                :hideBorder="hideBorder || (showElement && show )"
                :showQuantities=" ! element.isQuantityEditable "
                :key_spinner="'pem_' + randomId + '_' + child.product_id"
                :comeFromIsSimplePopup = "isSimplePopup || comeFromIsSimplePopup ? true : false"
                :comeFromIsDoublePopup = "isDoublePopup || comeFromIsDoublePopup ? true : false"
            ></productElementMobileComponent>
        </Fragment>

        <!-- -------------- -->
        <!-- MODAL VARIANTS -->
        <!-- -------------- -->
        <div
            ref="modalVariants"
            v-if="element.type == 2 && !isSimplePopup && !isDoublePopup"
            class="modal fade"
            :id=" 'modalVariant_' + randomId "
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-dialog-scrollable p-0 m-0" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">{{ $t('s4_titel_variants') }}</h5>
                        <button
                            type="button"
                            @click="closeVariantsModal()"
                            class="close"
                            v-show="false"
                            aria-label="Close"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body scrollable no_margin_padding_top_bott">
                        <productVariantsComponent
                            :element="element"
                            @variantChanged="onVariantChanged"
                        ></productVariantsComponent>
                    </div>
                    <div class="acceptButtonContainer">
                        <button
                            type="button"
                            aria-label="Close"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                            class="btn btn-dark acceptButtonVerticalCenter acceptButtonWidth"
                        >
                            {{ $t("accept_text") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- --------------------------- -->
        <!-- MODAL SOCKETS SELECTOR -->
        <!-- --------------------------- -->
        <div
            ref="modalSocketsSelector"
            v-if="isSimplePopup || isDoublePopup"
            class="modal fade"
            :id="'modalSockets_' + randomId"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-dialog-scrollable p-0 m-0" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">
                            {{ $t('s4_titel_variants') }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            v-show="false"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body scrollable">
                            <!-- :element="element" -->
                        <socketsSelectorComponent
                            ref="socketSelector"
                            :isDoublePopup="isDoublePopup"
                            :product_id="element.product_id"
                            :element_id="element.id"
                            @variantChanged="onVariantChanged"
                        ></socketsSelectorComponent>

                    </div>
                    <div class="acceptButtonContainer">
                        <button
                            aria-label="Close"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                            class="btn btn-dark acceptButtonVerticalCenter acceptButtonWidth"
                        >
                            {{ $t("accept_text") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </Fragment>
</template>


<script>
import Vue from "vue";
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import productElementComponent from "./productElement.vue";
import socketsSelectorComponent from "./socketsSelector.vue";
import productVariantsComponent from "./productVariants.vue";
import LightBox from "vue-image-lightbox";
import JQuery from "jquery";
let $ = JQuery;

export default {
    extends: productElementComponent,
    name: "productElementMobileComponent",
    components: {
        Fragment,
        productElementComponent,
        productVariantsComponent,
        LightBox
    },
    data() {
        return {
            app: app,
            randomId: Math.random()
                .toString(36)
                .replace(/[^a-z]+/g, "")
                .substr(2, 10),
            market: "",
            showElement: true,
            window: { width: 0, height: 0 },
            lastchangedInputId: "",
            timeout: {}

        };
    },
    props: {
        element: new Object(),
        elementIndex: 0,
        showQuantities: true, // If =true, shows individual quantities, if =false, show calculated quantities
        level: 0,
        parentType: 0,
        groupId: "",
        show: true,
        forceShowKits: false,
        hideBorder: false,
        key_spinner: "",
        comeFromIsSimplePopup: false,
        comeFromIsDoublePopup: false,
    },
    computed: {
        dontShowInputIsSelectionPopup: function(){
            if(this.isSimplePopup || this.isDoublePopup || this.comeFromIsSimplePopup || this.comeFromIsDoublePopup){
                return true;
            }
            return false;
        },
        dontShowSwitchComeFromSimpleOrDoublePopup: function(){
            if(this.comeFromIsSimplePopup || this.comeFromIsDoublePopup){
                return true;
            }
            return false;
        },
        isSimplePopup: function () {
            if( this.element.popup == 1) return true;

            return false;
        },
        isDoublePopup: function () {
            if( this.element.popup == 2) return true;

            return false;
        },
        showSeparationLine: function () {
            if (
                // si és de primer nivell i té childs, el mostrem si no està especificat lo contrari
                (this.level === 1 &&
                    this.element.childs &&
                    this.element.isKit &&
                    this.element.separator !== "hide") ||
                // si és kit i està especificat que el mostrem, el mostrem
                (this.element.isKit &&
                    this.element.separator == "show")
            ) {
                return true;
            }
            return false;
        },
        isProduct: function() {
            return !this.element.isKit;
        },

        showKitTitle: function() {
            // Els productes no son kits
            if (this.element.isKit == false) return false;

            // Si es un kit de tipus Variant, s'ha de mostrar:
            if (this.element.type == 2 && this.show) return true;

            // Si es un kit que es pot canviar la quantitat, s'ha de mostrar:
            if (this.isQuantityEditable) return true;

            // Proves Jaume:
            if (this.forceShowKits) return true;

            // Opcionals
            if (this.element.optional && this.show) return true;

        },

        showChilds: function() {
            //articles amb cantitat que venen de estar seleccionats al popup
            //si es vol que es mostrin o samaguin quests elements amb el switch comentar aixo
            if ((this.comeFromIsSimplePopup || this.comeFromIsDoublePopup) && this.articlesQuantity()) {
                return true;
            }

            // Kit opcional i seleccionat
            if (
                this.element.isKit == true &&
                this.element.optional &&
                this.element.selected
            ) {
                return true;
            }

            // Kit opcional i NO seleccionat
            if (
                this.element.isKit == true &&
                this.element.optional &&
                !this.element.selected
            ) {
                return false;
            }
            // KITS amb quantitats no editables, ensenyar els childs
            if (
                this.element.isKit == true &&
                !this.element.isQuantityEditable
            ) {
                return true;
            }

            // Quantitat editable i valor <> 0
            if (
                this.element.isKit == true &&
                this.element.isQuantityEditable &&
                this.element.quantity &&
                this.element.quantity != 0
            ) {
                return true;
            }

            // KIT de tipus variant
            if (this.element.type == 2) {
                return true;
            }
            return false;
        }
    },

    methods: {
        showSocketsModal: function() {
            // Wait till dom update
            // TODO: update socket selector
            let socketSelector = this.$refs.socketSelector
            console.warn("Update Socket Selector index:" + this.elementIndex)
            socketSelector.refresh(this.elementIndex);

            this.$nextTick(() => {
                let modal = this.$refs.modalSocketsSelector;
                $(modal).modal("show");
            });
        },
        closeSocketsModal(){
            this.$nextTick(() => {
                let modal = this.$refs.modalSocketsSelector;
                $(modal).modal("hide");
            });
        },
        closeVariantsModal(){
            this.$nextTick(() => {
                let modal = this.$refs.modalVariants;
                $(modal).modal("hide");
            });
        },
        articlesQuantity(childs = null) {
            //console.error('articlesQuantity...');
            let totalArticles = 0;
            let self = this

            if (this.element.isKit === 0) {
                // console.error('es article nivell 0: ', this.element.name, ' ', this.element.quantity);
                totalArticles += parseFloat(this.element.quantity);
            }
            if (!childs) {
                childs = this.element.childs;
            }

            Object.entries(childs).forEach(function (kitOrArticle) {

                if (kitOrArticle[1].isKit === 0) {
                    // console.error('es article nivell 1: ', kitOrArticle[1].name, ' ', kitOrArticle[1].quantity);
                    totalArticles += parseFloat(kitOrArticle[1].quantity);

                } else {
                    totalArticles += self.articlesQuantity(kitOrArticle[1].childs)

                }
            });

            return totalArticles;
        },
        getImagePreparedForLightbox(srcImage, titel) {
            let img = [
                {
                    thumb: srcImage,
                    src: srcImage,
                    caption: titel,
                    showCaption: true
                }
            ];

            return img;
        },
        clickedImageToZoom(imageName) {
            this.app.p3_zoomedImage = imageName;
        },
        closeLightbox(e) {
            //si event onOpened torna false es que sha tancat
            if (!e) {
                this.app.p3_zoomedImage = "";
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        ifCeroBlank: function() {
            console.error('this.element.quantity: ', this.element.quantity);
            this.element.quantity =
                this.element.quantity == 0
                    ? (this.element.quantity = "")
                    : this.element.quantity;
        },
        ifBlankCero: function(e) {
            this.element.quantity = this.element.quantity || 0;
        },
        quantityChanged: async function(e, key_remove_loading) {

            var self = this;

            //com a minim el valor ha de ser 0
            self.element.quantity = self.element.quantity || 0;

            //si usuari escriu nums haventhi ja un 0 treu el 0 de davant
            if (self.element.quantity.toString().startsWith("0")) {
                self.element.quantity = parseFloat(
                    self.element.quantity.toString().slice(1)
                );
            }

            //sempre en cualsevol cambi actualitza linea
            self.element.subtotal = self.element.quantity * self.element.price;

            if (self.lastchangedInputId != e.target.id) {
                self.lastchangedInputId = e.target.id;
                await self.processDelay(e, key_remove_loading);

            } else if (self.lastchangedInputId == e.target.id) {
                clearTimeout(self.timeout);
                await self.processDelay(e, key_remove_loading);
                self.lastchangedInputId = e.target.id;
            }
        },
        appendSpinnerToTextbox(ref){

            //create spinner
            var spinner = document.createElement('i');
            spinner.setAttribute('class', 'fa fa-spinner fa-spin mr-2');
            spinner.setAttribute('id', ref + '_spinner');

            //prepend spinner to parent of textbox
            this.$refs[ref].parentNode.prepend(spinner);

        },
        removeSpinnerFromTextbox(ref){
            document.getElementById(ref + '_spinner').remove();
            this.$refs[ref].parentNode.setAttribute('style', 'min-width:0px');
        },
        processDelay: async function(e, key_remove_loading) {
            var self = this;
            self.timeout = setTimeout(async function() {

                self.appendSpinnerToTextbox(key_remove_loading);

                await self.app.asyncProcess(false);

                self.removeSpinnerFromTextbox(key_remove_loading);

            }, 600);
        },
        onVariantChanged: async function(selectedChild) {
            this.element.childs.forEach(function(child, i) {
                if (child.product_id === selectedChild.product_id) {
                    child.selected = true;
                } else {
                    child.selected = false;
                }
            });
            await this.app.asyncProcess();
        },
        selectedChange: async function (event) {

            var self = this;

            if (this.element.selected && (this.isSimplePopup || this.isDoublePopup)) {
                this.showSocketsModal();

            //si usuari posa el switch a false mostra missatge de confirmacio de borrar cantitats i borrales
            }else if(!this.element.selected && (this.isSimplePopup || this.isDoublePopup)) {

                //demana confirmacio a usuari
                if (
                    await app.asyncModal(
                        app.translate("popup_S3_remove_element_warning"),
                        true
                    )
                ) {
                    //si usuari posa a off el switch posa a cero la cantitat
                    //de productes
                    Object.keys(self.element.childs).forEach(function(key){
                        self.element.childs[key].quantity = 0;
                        Object.keys(self.element.childs[key].childs).forEach(function(key2){
                            self.element.childs[key].childs[key2].quantity = 0;
                        })
                    })

                    await self.app.asyncProcess(false);

                }else{
                    //si usuari ha cancelat posa el switch a true
                    this.element.selected = true;
                }
            }else{

                await self.app.asyncProcess(false);
            }
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted() {

        let productQuantity = 0;

        //-------------------------
        //si la quantitat de sockets del popup doble es 0 al ser tanxat posa el switch a off
        //-------------------------
        let modal = this.$refs.modalSocketsSelector;
        var self = this;

        $(modal).on('hide.bs.modal', function () {

            productQuantity = 0;

            self.element.childs.forEach(function(child) {
                if(child.isKit){
                    if (typeof(child.childs) != 'undefined'){
                        child.childs.forEach(function(child2) {
                            if(child2.isKit){
                                if (typeof(child2.childs) != 'undefined'){
                                        child2.childs.forEach(function(child3) {
                                            productQuantity += child3.quantity
                                        })
                                }
                            }
                        })
                    }
            }
            });
            if(!productQuantity){
                self.element.selected = false;
            }
        });
        //-------------------------

        this.market = app.currentConfiguration.market.id;
        this.currency = app.currentConfiguration.priceList.currency;

        //Kits accessoris principals es mostrin en acordeo
        $(function() {
            $('button[data-bs-toggle="modal"]').on("click", function(event) {
                //mostra modal
                var datatarget = $(this).attr("data-target");
                $(datatarget).modal();

                //dintre del modal mostra les files directes de la taula del modal del kit opcional o variant
                $(
                    datatarget +
                        "> div > div > div.modal-body > table > tbody > tr"
                )
                    .css("display", "table-row")
                    .css("opacity", "1");
            });
        });
    },
    beforeMount() {
        // KITS amb quantitats editables, no ensenyar els childs
        if (this.element.isKit == true && this.element.isQuantityEditable) {
            this.showElement = true;
        }

        // KITS amb quantitats no editables, ensenyar els childs
        if (this.element.isKit == true && !this.element.isQuantityEditable) {
            this.showElement = false;
        }

        // KIT de tipus variant
        if (this.element.type == 2) {
            this.showElement = true;
        }

        // Si s'ha forçat a mostrar (camp showKitInfo)
        if( this.element.showKitInfo == 1){
            this.showElement = true;
        }

        // Si s'havia forçat a ocultar (camp showKitInfo)
        if( this.element.showKitInfo == -1){
            this.showElement = false;
        }
    }
};
</script>

<style scoped lang="scss">

@import "../../../node_modules/vue-image-lightbox/dist/vue-image-lightbox.min.css";

.position_bars{
    //position: relative;
    //top: -2px;
}

.buttonBarsSize{
    height: 31px;
    //width: 30px;
}

.scrollable {
    overflow: auto;
}


.acceptButtonContainer{
    width:100%;
}

.acceptButtonWidth{
    min-width: 60px
}

.acceptButtonVerticalCenter {
  margin: 0;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.backgr_white{
    background-color:white
}

.modal-mobile {
    max-width: 100% !important;
    width: 100% !important;
    position: fixed !important;
    bottom: 0 !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
     color: #fff;
    background-color: black;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.modal_bottom {
    position: fixed;
    bottom: 0;
}

.pointerHoverZoom:hover {
    cursor: pointer;
}
</style>
